export default __webpack_public_path__ + "static/media/product.48749998.png";